import { IAgreementServices } from './agreement.types'
import { http } from '@/shared/https'
import moment from 'moment';

export class AgreementService implements IAgreementServices {

    /** method to get the reporting periods */
    getReportingPeriods(startDate: any, endDate: any, frequency: number, startIndex: number = 0) {

        const dt1 = moment(startDate);
        const dt2 = moment(endDate);

        const months = Math.ceil(dt2.diff(dt1, 'months', true));

        let numberOfPeriods = Math.ceil(months / frequency);

        let freqText: string = '';
        let freqCode: string = '';

        /** frequency */
        switch(frequency) {
            case 3:
                freqText = 'Quarter';
                freqCode = 'Q';
                break;
            case 6:
                freqText = 'Half';
                freqCode = 'H';
                break;
            case 12:
                freqText = 'Year';
                freqCode = 'Y';
                break;
        }

        // #. derive the reporting period
        let reportingPeriod =  [...Array(numberOfPeriods).keys()].map(x => x + startIndex).reduce((x, c) => {

            const year = Math.ceil((frequency * (c + 1) ) / 12);
            const period = (c % (12 / frequency)) + 1;
            let title = `Y${year}${freqCode}${period}`;
            let description = (freqCode == 'Y') ? `Year${year}` : `Year${year} - ${freqText}${period}`;

            let d1 = moment(dt1).add((c * frequency), 'M');
            let d2 = moment(dt1).add(((c + 1) * frequency), 'M').subtract(1, 'd');
            let d3 = moment(dt1).add((((c + 1) * frequency) + 1), 'M').subtract(1, 'd');

            if(d2 >= moment(dt2).subtract(1, 'd')) {
                d2 = moment(dt2);
                d3 = moment(dt2).add(2, 'M');
            }   

            x.push({
                title,
                description,
                period: freqCode,
                startDate: moment(d1).format('YYYY-MM-DD'),
                endDate: moment(d2).format('YYYY-MM-DD'),
                dueDate: moment(d3).format('YYYY-MM-DD'),
            });
            return x;

        }, []);

        return reportingPeriod;
    }

    /** get the communication periods */
    getCommunicationPeriods(startDate: any, endDate: any, periods: any, selectedPeriods: Array<string>, gracePeriod: number)
    {
        const dt1 = moment(startDate);
        const dt2 = moment(endDate);

        const days = Math.ceil(dt2.diff(dt1, 'days', true));

        // let frequency = (months / selectedPeriods.length);

        let reportPeriods = [];

        let firstUpdateDeadline = moment(dt1).add(2, 'M').add(1, 'd');
        let secondUpdateDeadline = moment(dt1).add((days / 2), 'd');
        let thirdUpdateDeadline = moment(dt2).add(1, 'M').add(1, 'd');

        // #. First period (1st month)
        reportPeriods.push({ StartDate: moment(dt1), EndDate: moment(firstUpdateDeadline).subtract(29, 'd') });
        // #. Second Period (2nd month)
        reportPeriods.push({ StartDate: moment(firstUpdateDeadline).subtract(29, 'd'), EndDate: firstUpdateDeadline });
        // #. Third period (half way)
        reportPeriods.push({ StartDate: moment(secondUpdateDeadline).subtract(31, 'd') , EndDate: secondUpdateDeadline});
        // #. Fourth period (after completion)
        reportPeriods.push({ StartDate: moment(thirdUpdateDeadline).subtract(31, 'd'), EndDate: thirdUpdateDeadline});

        // #. derive the reporting period
        let communicationPeriod =  periods.filter(x => selectedPeriods.includes(x.step_id) ).reduce((x, c, i) => {
            
            x.push({
                StepId: c.step_id,
                Description: c.description,
                StartDate: (reportPeriods[i]) ? moment(reportPeriods[i].StartDate).format('YYYY-MM-DD'): '',
                EndDate: (reportPeriods[i]) ? moment(reportPeriods[i].EndDate).format('YYYY-MM-DD'): ''
            });
            return x;

        }, []);

        return communicationPeriod;
    }

    /** get communication template */
    getCommunicationTemplate(callId: number) {
        return http.get(`api/GrantCommunication/${callId}/Template`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        });
    }

    /** validate start date */
    validateCommunicationStartDate(period: any, val: any, startDate: any, endDate: any ): string {
        let msg: string = '';        

        // #. check whether with in the duration        
        // if( moment(startDate) > moment(val) || moment(endDate) < moment(val) )
        //     msg = (msg) ? `${msg} <br/> Communication reports must be with in the project duration.` : "Communication reports must be with in the project duration."

        // #. check whether less than the end date
        if(period.EndDate && moment(period.EndDate) <= moment(val) )
            msg = (msg) ? `${msg} <br/> Start date must be less than the End date.` : "Start date must be less than the End date."

        return msg;
    }

    /** validate end date */
    validateCommunicationEndDate(period: any, val: any, startDate: any, endDate: any, gracePeriod: number): string {
        let msg: string = '';        

        // #. check whether with in the duration        
        // if( moment(startDate) > moment(val) || (moment(endDate).add(gracePeriod ||  1,'M')) < moment(val) )
        //     msg = (msg) ? `${msg} <br/> Communication reports must be with in the project duration.` : "Communication reports must be with in the project duration."

        // #. check whether less than the end date
        if(period.StartDate && moment(period.StartDate) >= moment(val) )
            msg = (msg) ? `${msg} <br/> End date must be greater than the Start date.` : "End date must be greater than the Start date."
       

        return msg;
    }


    /** validate start date */
    validateStartDate(periods: any, period: any, index: number, val: any, datum: any, startDate: any, endDate: any ): string {
        let msg: string = '';

        // #. check whether periods overlapped.
        const overlappedRow = periods
        .find( (x, i) => {
            if( moment(x.startDate) <= moment(val) && moment(x.endDate) >= moment(val) && i !== index )
                return true; 
        });

        if(overlappedRow)
            msg = "Reporting periods must not overlapped."

        // #. check whether with in the duration        
        if( moment(startDate) > moment(val) || moment(endDate) < moment(val) )
            msg = (msg) ? `${msg} <br/> Reporting periods must be with in the project duration.` : "Reporting periods must be with in the project duration."

        // #. check whether less than the end date
        if(period.endDate && moment(period.endDate) <= moment(val) )
            msg = (msg) ? `${msg} <br/> Start date must be less than the End date.` : "Start date must be less than the End date."

        // #. check whether less than the due date
        if(period.dueDate && moment(period.dueDate) <= moment(val) )
            msg = (msg) ? `${msg} <br/> Start date must be less than the Due date.` :"Start date must be less than the Due date."

        return msg;

    }

    /** validate end date */
    validateEndDate(datum: any, period: any, index: number, val: any, key: string, frequency: number, startDate: any, endDate: any ): string {
        let msg: string = '';    
        
        if(!datum[key]) {
            datum[key] = [];
        }

        // #. check whether with in the duration        
        if( moment(startDate) > moment(val) || moment(endDate) < moment(val) )
            msg = (msg) ? `${msg} <br/> Reporting periods must be with in the project duration.` : "Reporting periods must be with in the project duration."

        // #. check whether less than the end date
        if(period.startDate && moment(period.startDate) >= moment(val) )
            msg = (msg) ? `${msg} <br/> End date must be greater than the Start date.` : "End date must be greater than the Start date."

        if(!msg) {
            period.endDate = moment(val).format('YYYY-MM-DD');
            let d3 = moment(val).add(1, 'M');
            period.dueDate = moment(d3).format('YYYY-MM-DD');

            let remainingPeriods = this.getReportingPeriods(moment(val).add(1, 'd'), endDate, frequency, index + 1);

            datum[key] = [...datum[key].splice(0, index + 1), ...remainingPeriods];
        }

        return msg;
    }

    /** validate due date */
    validateDueDate(periods: any, period: any, index: number, val: any, datum: any, startDate: any, endDate: any ): string {
        let msg: string = '';

        // #. check whether with in the duration        
        // if( moment(startDate) > moment(val) || (moment(endDate).add(2, 'M')) < moment(val) )
        //     msg = (msg) ? `${msg} <br/> Reporting periods must be with in the project duration.` : "Reporting periods must be with in the project duration."

        // #. check whether less than the end date
        if(period.startDate && moment(period.startDate) >= moment(val) )
            msg = (msg) ? `${msg} <br/> Due date must be greater than the Start date.` : "Due date must be greater than the Start date."

        // #. check whether less than the due date
        if(period.endDate && moment(period.endDate) > moment(val) )
            msg = (msg) ? `${msg} <br/> Due date must be greater than or equal to the End date.` :"Due date must be greater than or equal to the End date."

        return msg;
    }

    updatePeriod(periods: any, period: any, index: number, datum: any, reportFrequency: number, startDate: any, endDate: any ) {

        if(period.period) {
            if(period.startDate != null) {
                let frequency = 0;
                switch(period.period) {
                    case 'Q':
                        frequency = 3;
                        break;
                    case 'H':
                        frequency = 6;
                        break;
                    case 'Y':
                        frequency = 12;
                        break;
                }
                let d2 = moment(period.startDate).add(frequency, 'M').subtract(1, 'd');
                let d3 = moment(d2).add(1, 'M');

                period.endDate = moment(d2).format('YYYY-MM-DD');
                period.dueDate = moment(d3).format('YYYY-MM-DD');
                
                if(moment(period.endDate) >= moment(endDate).subtract(1, 'd')){
                    let d2 = moment(endDate).add(2, 'M');

                    period.endDate = moment(endDate).format('YYYY-MM-DD');
                    period.dueDate = moment(d2).format('YYYY-MM-DD');   
                    
                    periods[index] = period;
                } else {
                    periods[index] = period;

                    let remainingPeriods = this.getReportingPeriods(moment(period.endDate).add(1, 'd'), endDate, reportFrequency, index + 1);

                    periods = [...periods.splice(0, index + 1), ...remainingPeriods];                    
                }                
            }
        }
        return periods;
    }
}
